import {Param} from "./param";

export {Param as Ref};
